import { CommodityStatusCode, PersonaType } from '@bechtel/types';

export interface BulkRequestProps {
  bulkRequest: boolean;
  selectedWeldIds: string[];
  selectAllWeldList: (isWps?: boolean) => void;
  setBulkRequest: (bulkRequest: boolean) => void;
  weldListCount: number;
  selectItems: (value: boolean) => void;
  createBulkRodRequest?: () => void;
  selectedTab: CommodityStatusCode;
  setSelectedWeldItems: (items: []) => void;
  canAssignFieldWeldEngineer: boolean;
  canCreateRodRequest: boolean;
}
